"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTERED_USER_EVENT = void 0;
const REGISTERED_USER_EVENT = exports.REGISTERED_USER_EVENT = 'user-registered';